import { t } from "@lingui/macro";

import { useMyResumes } from "@/client/services/resume/my-resumes";
import { useUser } from "@/client/services/user";

import { DashboardContent } from "../components/layout/dashboard-content";
import { DashboardHeader } from "./dashboard-header";
import { DashboardMetrics } from "./dashboard-metrics";
import { EmptyDashboard } from "./empty-dashboard";
import { RecentDocuments } from "./recent-documents";

const DocumentsLoadingState = () => {
  return (
    <div role="status" aria-label="Chargement des documents">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="h-6 w-36 animate-pulse rounded-full bg-slate-200" />

        <div className="h-10 w-full animate-pulse rounded-xl bg-slate-200 sm:w-40" />
      </div>

      <div className="mt-4 grid gap-3 md:grid-cols-2 xl:grid-cols-3">
        {Array.from({
          length: 6,
        }).map((_, index) => (
          <div
            key={index}
            aria-hidden
            className="h-32 animate-pulse rounded-2xl border border-slate-200 bg-slate-100"
          />
        ))}
      </div>

      <span className="sr-only">Chargement des documents…</span>
    </div>
  );
};

export const DashboardPage = () => {
  const { user } = useUser();

  const { resumes, loading, error } = useMyResumes(user?.id);

  const hasDocuments = (resumes?.length ?? 0) > 0;

  return (
    <DashboardContent>
      <DashboardHeader userName={user?.name} />

      <DashboardMetrics />

      <section
        aria-labelledby="documents-title"
        className={`mt-5 rounded-2xl border border-slate-200 bg-white p-4 shadow-sm sm:p-5`}
      >
        <h2 id="documents-title" className="text-base font-bold text-indigo-950 sm:text-lg">
          {t`Mes documents`}
        </h2>
        <p className="mt-1 text-xs leading-5 text-slate-500">
          {t`Créez ou importez un document professionnel.`}
        </p>
        <div className="mt-4">
          <EmptyDashboard />
        </div>
      </section>

      {(loading || error || hasDocuments) && (
        <section
          aria-label={t`Mes CV`}
          className="mt-5 rounded-2xl border border-slate-200 bg-white p-4 shadow-sm sm:p-5"
        >
          {loading ? (
            <DocumentsLoadingState />
          ) : error ? (
            <div role="alert" className="rounded-2xl border border-rose-200 bg-rose-50 px-4 py-3">
              <p className="text-xs font-semibold text-rose-800 sm:text-[13px]">
                {t`Impossible de charger vos CV. Actualisez la page pour réessayer.`}
              </p>
            </div>
          ) : (
            <RecentDocuments resumes={resumes ?? []} />
          )}
        </section>
      )}
    </DashboardContent>
  );
};
